<template>
  <div class="bg-white border border-border rounded-md lg:mb-5 mb-4">
    <div class="flex w-full  border-b border-border !m-0 p-4 gap-[8px] items-center">
      <span class="number-badge">
        <span v-if="(state.opt_type != 'general' && state.opt_type != 'SEIU721')">2</span>
        <span v-if="(state.opt_type == 'general' || state.opt_type == 'SEIU721')">3</span>
      </span>
      <h6 class="card-title !m-0">Select a Plan</h6>
    </div>
    <div class="p-4">
      <div class="justify-start gap-4 grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-2 grid-cols-1"
        v-if="state.disp_enroll_section && !state.disp_err_msg">
        <div v-for="(group, idx) in state.bundled_group" :key="`${group.id}-${idx}`"
          class="left-card flex flex-col bg-primaryLight border rounded-md card-select">
          <span :id="`plan-a11y-${idx}`" class="sr-only">
            {{ group.description }}.
            {{ state.company.company_name }}. {{ group.state }}.
            <span v-if="state.payroll_enrollment !== '1'">
              <span v-if="state.payment_frequency === 1">Annual</span>
              <span v-else-if="state.payment_frequency === 2">Semi-Annual</span>
              <span v-else-if="state.payment_frequency === 4">Per Quarter</span>
              <span v-else-if="state.payment_frequency === 9">9 Pay Periods</span>
              <span v-else-if="state.payment_frequency === 12">Per Month</span>
              <span v-else-if="state.payment_frequency === 20">20 Pay Periods</span>
              <span v-else-if="state.payment_frequency === 22">22 Pay Periods</span>
              <span v-else-if="state.payment_frequency === 24">Semi-Monthly</span>
              <span v-else-if="state.payment_frequency === 26">Bi-Weekly</span>
              <span v-else-if="state.payment_frequency === 52">Per Week</span>
              premium: ${{ group.monthly_premium }}.
            </span>
            <span v-else>
              Premium: ${{ group.monthly_premium }}.
            </span>
            <span v-if="state.payment_method == 'CC'">
              Prorated Premium: ${{ group.prorated_premium }}.
              Service Fee: {{ state.service_fee }}.
            </span>
            Final Amount:
            <span v-if="state.payment_method != 'Payroll'">${{ group.total }}</span>
            <span v-else>${{ group.total_monthly_prem }}</span>.
          </span>
          <div class="flex justify-start gap-4 card-header p-4 border-b border-border">
            <span
              class="w-[50px] h-[50px] bg-white border border-border flex rounded-md items-center justify-center shrink-0">
              <img v-if="getPlanIcon(group) === 'CDL'" src="@/assets/images/truck.svg" alt="CDL">
              <img v-else-if="getPlanIcon(group) === 'FAM'" src="@/assets/images/balance.svg" alt="FAM">
              <img v-else src="@/assets/images/idd.png" alt="IDD">

            </span>
            <div class="flex justify-between items-start flex-1">
              <div class="basis-[75%]">
                <h6 class="card-title !mb-1 !uppercase" :id="`plan-title-${idx}`">{{ group.description }}</h6>
                <ul class="list-none m-0 p-0 flex justify-start gap-[14px]">
                  <li class="relative li-divider">
                    <p class="content !m-0">{{ state.company.company_name }}</p>
                  </li>
                  <li class="relative li-divider">
                    <p class="content !m-0 uppercase">{{ group.state }}</p>
                  </li>
                </ul>
              </div>
              <div class="text-end">
                <h6 class="card-title !mb-1">${{ group.planFee }}</h6>
                <p class="content !mb-0" v-if="state.payroll_enrollment != '1'">/month</p>
              </div>
            </div>
          </div>
          <div class="card-body flex-1">
            <div class="p-4 rounded-md bg-primaryLight">
              <div class="flex justify-between mb-2.5" :id="`plan-summary-${idx}`">
                <p class="content !mb-0" v-if="state.payroll_enrollment !== '1'">
                  <span v-if="state.payment_frequency === 1">Annual</span>
                  <span v-else-if="state.payment_frequency === 2">Semi-Annual</span>
                  <span v-else-if="state.payment_frequency === 4">Per Quarter</span>
                  <span v-else-if="state.payment_frequency === 9">9 Pay Periods</span>
                  <span v-else-if="state.payment_frequency === 12">Per Month</span>
                  <span v-else-if="state.payment_frequency === 20">20 Pay Periods</span>
                  <span v-else-if="state.payment_frequency === 22">22 Pay Periods</span>
                  <span v-else-if="state.payment_frequency === 24">Semi-Monthly</span>
                  <span v-else-if="state.payment_frequency === 26">Bi-Weekly</span>
                  <span v-else-if="state.payment_frequency === 52">Per Week</span>
                </p>
                <p class="content !mb-0" v-if="state.payroll_enrollment == '1'">
                  Premium
                </p>
                <span class="content !text-blackPrimary !mb-0 !font-bold">${{ group.monthly_premium }}</span>
              </div>

              <div class="flex justify-between mb-2.5" v-if="state.payment_method == 'CC'">
                <p class="content !mb-0">Prorated Premium</p>
                <span class="content !text-blackPrimary !mb-0 !font-bold">${{ group.prorated_premium }}</span>
              </div>

              <div class="flex justify-between mb-2.5" v-if="state.payment_method == 'CC'">
                <p class="content !mb-0">Service Fee</p>
                <span class="content !text-blackPrimary !mb-0 !font-bold">${{ state.service_fee }}</span>
              </div>

              <div class="flex justify-between mb-0">
                <p class="content !font-bold !mb-0 !text-blackPrimary">Final Amount</p>
                <span v-if="state.payment_method != 'Payroll'"
                  class="content !mb-0 !font-bold !text-lg !text-primary">${{ group.total }}</span>
                <span v-if="state.payment_method == 'Payroll'"
                  class="content !mb-0 !font-bold !text-lg !text-primary">${{ group.total_monthly_prem }}</span>

              </div>
            </div>
          </div>
          <div class="w-100 p-4 card-button border-t border-border" v-if="group.select_plan == true">
            <button
              class="primary-button w-full text-center inline-flex justify-center items-center gap-2"
              :aria-labelledby="`plan-title-${idx} plan-summary-${idx}`"
              :aria-describedby="`plan-a11y-${idx}`"
            >
              <img src="@/assets/images/correct.svg" alt="correct" />
              Selected
            </button>
          </div>
          <div class="w-100 p-4 card-button border-t border-border" v-if="group.select_plan == false">
            <button
              class="primary-outline-button plan-select-contrast w-full text-center inline-flex justify-center items-center gap-2"
              :aria-labelledby="`plan-title-${idx} plan-summary-${idx}`"
              :aria-describedby="`plan-a11y-${idx}`"
              @click="selectPlan(state.bundled_group, group)">
              <img src="images/correct.svg" alt="correct" class="hidden">
              Select
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
  <SelectedPlanInfoMob :state="state" />
</template>

<script>
import SelectedPlanInfoMob from "./SelectedPlanInfoMob.vue";

export default {
  name: "PlanSelectionSection",
  data() {
    return {
    };
  },
  components: {
    SelectedPlanInfoMob,
  },
  props: {
    state: Object,
  },
  emits: ["setChoice", "getPlanListAgain"],
  methods: {
    getPlanIcon(group) {
      const planType = (group?.planType || "").toString().toUpperCase();
      if (planType === "CDL" || planType === "FAM" || planType === "IDD") {
        return planType;
      }

      const description = (group?.description || "").toString().toUpperCase();
      const planCode = (group?.plan_code || "").toString().toUpperCase();

      if (description.includes("CDL") || planCode.includes("CDL")) return "CDL";
      if (
        description.includes("FAMILY") ||
        description.includes("FAM") ||
        planCode.includes("FAM")
      )
        return "FAM";
      return "IDD";
    },
    selectPlan(bundled_group, group) {
      this.$emit("setChoice", bundled_group, group);
    }
  },
};
</script>

<style scoped>
/* Add component-specific styles here if needed */
.card-select {
  border-color: #3490dc;
  /* Highlight the selected card */
  box-shadow: 0 0 10px rgba(52, 144, 220, 0.3);
}

/* WCAG: increase contrast for "Select" outline button only */
.plan-select-contrast {
  color: #b23f22 !important;
  border-color: #b23f22 !important;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>